import { UPDATE_SUGGESTED as UPDATE_SUGGESTED_SALES } from 'actionCreators/comparableSales';
import { UPDATE_SUGGESTED as UPDATE_SUGGESTED_LISTINGS } from 'actionCreators/comparableListings';
import { UPDATE_SUGGESTED as UPDATE_SUGGESTED_RENTALS } from 'actionCreators/comparableRentals';
import { UPDATE as UPDATE_SALES } from 'actionCreators/comparableSales';
import { UPDATE as UPDATE_LISTINGS } from 'actionCreators/comparableListings';
import { UPDATE as UPDATE_RENTALS } from 'actionCreators/comparableRentals';
import { RESET, LOAD_PROPERTY_DETAILS } from 'ducks/propertyDetail';
import { LOADER, UNLOADER } from 'constants/loader';

export const REDUX_BLOCKING = [
    UPDATE_SUGGESTED_SALES,
    UPDATE_SUGGESTED_LISTINGS,
    UPDATE_SUGGESTED_RENTALS,
    LOAD_PROPERTY_DETAILS,
    LOADER,
];
export const REDUX_UNBLOCKING = [
    UPDATE_SALES,
    UPDATE_LISTINGS,
    UPDATE_RENTALS,
    RESET,
    UNLOADER,
];